var React = require('react');

function Share (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ICONS_nieuwwwwww"),React.createElement("path",{"d":"M58.38,27A13.52,13.52,0,1,0,44.86,13.51a13.3,13.3,0,0,0,.65,3.92L23.35,30.35a13.51,13.51,0,1,0-.12,18.59L45.7,62.06a13.56,13.56,0,1,0,3.6-5.41L26.43,43.34a13.38,13.38,0,0,0,.6-3.76,13.34,13.34,0,0,0-.55-3.6L48.75,23A13.49,13.49,0,0,0,58.38,27Z","fill":"#f1b860","key":1})]);
}

Share.defaultProps = {"viewBox":"0 0 71.89 80.12"};

module.exports = Share;

Share.default = Share;
